var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { context as FetchContext } from '@ies/ssr-fetch';
var withFetchContext = function (App, options) {
    var AppWithFetchContext = function (props) {
        var fetcherContext = {
            ctx: options.ctx,
            id: 0,
            fetcherCollector: options.fetcherCollector,
        };
        return (React.createElement(FetchContext.Provider, { value: fetcherContext },
            React.createElement(App, __assign({}, props))));
    };
    AppWithFetchContext.getInitialProps = App.getInitialProps;
    return AppWithFetchContext;
};
export default withFetchContext;
